import { addDays, addMinutes, setHours, setMinutes, startOfDay } from 'date-fns';

interface ResolveResourceScheduleTimelineBoundsOptions {
  selectedDate: Date;
  visibleStartHour: number;
  slotCount: number;
  intervalMinutes: number;
}

export function resolveResourceScheduleTimelineStart(
  selectedDate: Date,
  visibleStartHour: number,
): Date {
  let dayOffset = 0;
  let displayHour = visibleStartHour;

  if (visibleStartHour >= 24) {
    displayHour = visibleStartHour - 24;
    dayOffset = 1;
  } else if (visibleStartHour < 0) {
    displayHour = visibleStartHour + 24;
    dayOffset = -1;
  }

  const base = addDays(startOfDay(selectedDate), dayOffset);
  return setHours(setMinutes(base, 0), displayHour);
}

export function resolveResourceScheduleTimelineBounds({
  selectedDate,
  visibleStartHour,
  slotCount,
  intervalMinutes,
}: ResolveResourceScheduleTimelineBoundsOptions): {
  timelineStart: Date;
  timelineEnd: Date;
} {
  const timelineStart = resolveResourceScheduleTimelineStart(selectedDate, visibleStartHour);
  const safeSlotCount = Math.max(0, slotCount);
  const timelineEnd = addMinutes(timelineStart, safeSlotCount * intervalMinutes);

  return {
    timelineStart,
    timelineEnd,
  };
}